import { Link } from "react-router-dom";

const STEPS = [
  ["01", "Discover", "Regional context", "/discover"],
  ["02", "Explore", "Opportunities", "/explore"],
  ["03", "Evaluate", "Investment case", "/evaluate"],
  ["04", "Validate", "Information", "/validate"],
  ["05", "Engage", "Investor interest", "/engage"],
  ["06", "Mobilise", "Capital & partnerships", "/mobilise"],
];

export const JourneyRail = ({ active }) => (
  <div data-testid="journey-rail" className="relative flex justify-between">
    <div className="absolute left-5 right-5 top-5 h-px bg-slate-500/50" />
    {STEPS.map(([n, name, sub, to]) => {
      const on = name.toLowerCase() === active;
      return (
        <Link key={n} to={to} data-testid={`journey-step-${name.toLowerCase()}`} className="relative z-10 flex w-[16%] flex-col items-center text-center">
          <span className={`grid h-10 w-10 place-items-center rounded-full border text-[13px] font-bold transition-colors ${on ? "border-[#F4B842] bg-[#F4B842] text-[#06142A] shadow-[0_0_0_4px_rgba(244,184,66,.25)]" : "border-slate-400/60 bg-[#0B1F38] text-white hover:border-white"}`}>{n}</span>
          <span className={`mt-1.5 text-[11.5px] font-semibold ${on ? "text-[#F4B842]" : "text-slate-200"}`}>{name}</span>
          <span className={`text-[10px] leading-tight ${on ? "text-[#F4B842]" : "text-slate-400"}`}>{sub}</span>
        </Link>
      );
    })}
  </div>
);
